import { render, staticRenderFns } from "./month.vue?vue&type=template&id=b877be04&scoped=true&"
import script from "./month.vue?vue&type=script&lang=js&"
export * from "./month.vue?vue&type=script&lang=js&"
import style0 from "./month.vue?vue&type=style&index=0&id=b877be04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b877be04",
  null
  
)

export default component.exports